import { ILNBType, IFolderLNBType, HIDE_TYPE } from '../../../interface/header/IMenu';

const findVisibleSubMenu = (folderMenu: ILNBType<IFolderLNBType>) => {
  const visibleSubMenu = folderMenu.subMenuList.filter(({ hideType }) => hideType === HIDE_TYPE.VISIBLE);
  return visibleSubMenu;
};

export default findVisibleSubMenu;
